/* PaywallProvider — listens for the global `paywall:show` window event
 * (fired by the axios 402 interceptor in `lib/api.js`) and mounts the
 * PaywallSheet exactly once at the app root.
 *
 * Mount this ONCE near the top of <App>, AFTER the router but BEFORE any
 * page so that the sheet can navigate to /account/subscription correctly.
 */
import { useEffect, useState } from "react";
import PaywallSheet from "./PaywallSheet";

export default function PaywallProvider({ children }) {
  // Active payload (the 402 `detail` object) — when null the sheet is hidden.
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    const onShow = (e) => {
      // Defensive: ignore events with no detail (shouldn't happen but
      // protects against partial integrations).
      const d = e?.detail;
      if (!d) return;
      setPayload(d);
    };
    window.addEventListener("paywall:show", onShow);
    return () => window.removeEventListener("paywall:show", onShow);
  }, []);

  return (
    <>
      {children}
      <PaywallSheet payload={payload} onClose={() => setPayload(null)} />
    </>
  );
}
